import { render, staticRenderFns } from "./CTraining.vue?vue&type=template&id=5ba5dbdd"
import script from "./CTraining.vue?vue&type=script&lang=js"
export * from "./CTraining.vue?vue&type=script&lang=js"
import style0 from "./CTraining.vue?vue&type=style&index=0&id=5ba5dbdd&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ba5dbdd')) {
      api.createRecord('5ba5dbdd', component.options)
    } else {
      api.reload('5ba5dbdd', component.options)
    }
    module.hot.accept("./CTraining.vue?vue&type=template&id=5ba5dbdd", function () {
      api.rerender('5ba5dbdd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CTraining.vue"
export default component.exports